<template>
  <div>
    <h1>Boat House Page</h1>
    <p>Content for Boat House.</p>
  </div>
</template>

<script>
export default {
  name: 'BoatHouse'
}
</script>

<style>
/* 添加样式 */
</style>
